import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Col, Label} from "reactstrap"
import DateTime from "react-datetime"

class FilterDateTime extends Component {
    render() {
        const {column, value, placeholder, label, onChange} = this.props
        return (
            <Col md={column}>
                <Label>{label}</Label>
                <DateTime
                    onChange={onChange}
                    closeOnSelect={true}
                    value={value ? value : ''}
                    dateFormat="DD/MM/YYYY"
                    timeFormat={false}
                    inputProps={{placeholder: placeholder}}
                />
            </Col>
        )
    }
}

FilterDateTime.propTypes = {
    column: PropTypes.number.isRequired,
    value: PropTypes.string,
    placeholder: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
}

export default FilterDateTime
